import React from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import AuthenticationService from '../auth/AuthenticationService';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        backgroundColor: '#fafafa', 
        paddingTop: 8
    }
  })
);

interface Props {
    authService: AuthenticationService;
}

function ApiSwaggerDocs(props: Props) {
    const classes = useStyles({});

    const reqInterceptor = (req) => {
        return props.authService.getAccessToken().then(token => {
            req.headers.Authorization = token;
            return req;
        });
    };

    return <div className={classes.root}>
        <SwaggerUI 
            requestInterceptor={reqInterceptor} 
            url={`${process.env.REACT_APP_API_URL}/swagger.yaml`} 
            docExpansion="list"
        />
    </div>;
}

export default ApiSwaggerDocs; 
